import React from 'react';
import { priceFormat } from '../../../util';

const Price = (props) => {
  const { value, isValueSetInCents = false, currencyCode } = props;
  const price = priceFormat(isValueSetInCents && typeof value === 'number' ? value / 100 : value, currencyCode);

  return <>{price}</>;
};
export default React.memo(Price);
